import Vue from "vue";
import PreLoader from "@/components/preloader";
import SectionHeader from "@/components/section-header";
import HTTPResponse from "@/components/http-response";
import ProcessLoader from "@/components/process-loader";
import ServiceSettings from "@/components/ServiceDetails/service-settings";
import SecuritySettings from "@/components/ServiceDetails/edit-service";
import ServiceStatus from "@/components/ServiceDetails/ServiceStatus";
import EditActions from "@/components/ServiceDetails/edit-actions"
import RequestIp from "@/components/ServiceDetails/request-ip";
import NBNOptions from "@/components/ServiceDetails/nbn-options";
import UserService from "@/components/ServiceDetails/user-service";
import EditWholesaler from "@/components/edit-wholesaler";
import AddWholesaler from "@/components/add-wholesaler";
import IpManagement from "@/components/edit-ip";
import IpRange from "@/components/ip-range";
import Warning from "@/components/warning";
import Confirm from "@/components/confirm";

Vue.component("preloader", PreLoader);
Vue.component("section-header", SectionHeader);
Vue.component("http-response", HTTPResponse);
Vue.component("process-loader", ProcessLoader);
Vue.component("service-settings", ServiceSettings);
Vue.component("edit-service", SecuritySettings);
Vue.component("service-status", ServiceStatus);
Vue.component("request-ip", RequestIp);
Vue.component("edit-actions", EditActions);
Vue.component("nbn-options", NBNOptions);
Vue.component("user-service", UserService);
Vue.component("edit-wholesaler", EditWholesaler);
Vue.component("add-wholesaler", AddWholesaler);
Vue.component("edit-ip", IpManagement);
Vue.component("ip-range", IpRange);
Vue.component("warning", Warning);
Vue.component("confirm", Confirm);

